import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportTopSectorAndOccupationByISCED4 = async (urlDataAPI: any) => {
    const { exportType, type, title, hubIds, ISCED4Codes, locations, fromQuarter, toQuarter, isEntryLevel } = urlDataAPI;
    const { path, method } = endpoints.educationCareerPath.exportTopSectorAndOccupationByISCED4;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, type, title, hubIds, ISCED4Codes, locations, fromQuarter, toQuarter, isEntryLevel },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
